/* eslint max-lines: 0 */
import { Navigate, Outlet } from 'react-router-dom';
import { routes } from 'app/routing/routesConfig';
import { WebWrapper } from 'app/components/WebWrapper';
import { webRoutes } from 'app/routing/routes/web';
import { AppRedirect } from 'app/views/AppRedirect';
import { UnsupportedMobile } from 'app/components/UnsupportedMobile';
import { InitializationLayer } from 'app/components/InitializationLayer';
import { QrWindow } from 'app/components/Song';
import {
  AppDownload,
  ConfirmAccount,
  ConfirmAccountSuccess,
  Notifications,
  PasswordReset,
  Playlists,
  Profile,
  Release,
  Releases,
  ReleaseVersion,
  Settings,
  SignIn,
  SignOut,
  SignUp,
  Song,
} from 'app/views';
import { App } from 'app/App';
import { PrivateRoute } from 'app/routing/components/PrivateRoute';
import { Songs } from 'app/views/Songs';
import { IndexNavigate } from 'app/routing/components/IndexNavigate';
import { PageNotFound } from 'app/views/PageNotFound';
import { songRoutes } from 'app/routing/routes/song';
import { profileRoutes } from 'app/routing/routes/profile';
import { PublicRoute } from 'app/routing/components/PublicRoute';
import { releaseVersionRoutes } from 'app/routing/routes/releases';
import { Auth } from 'app/routing/components/AuthRoute';
import { Root } from 'app/Root';
import { Playlist } from 'app/views/Playlist';
import { Messages } from 'app/views/Messages';
import { Shares } from 'app/components/Shares';
import { WebPageNotFound } from 'app/components/WebPageNotFound';
import { PrivacySettings } from 'app/views/PrivacySettings';
import { SongFolder } from 'app/views/SongFolder';
import { Import } from 'app/views/Import';
import { AudioPlayerPlaylistView } from 'app/views/AudioPlayerPlaylist';
import { AudioPlayerLyricsView } from 'app/views/AudioPlayerLyrics';
import { AudioPlayerSharedLyrics } from 'app/views/AudioPlayerSharedLyrics';

export const appRoutes = [
  {
    path: '/',
    element: <Root />,
    children: [
      {
        path: routes.web.route,
        element: <WebWrapper />,
        children: webRoutes,
      },
      {
        path: routes.play.route,
        element: <WebWrapper />,
        children: [
          {
            path: routes.sharesPlay.route,
            element: <Shares />,
            children: [
              {
                path: routes.sharesPlayLyrics.route,
                element: <AudioPlayerSharedLyrics />,
              },
            ],
          },
          {
            path: routes.webPageNotFound.route,
            element: <WebPageNotFound />,
          },
          { path: '*', element: <Navigate to={routes.webPageNotFound.path} /> },
        ],
      },
      {
        path: routes.appRedirect.route,
        element: <AppRedirect />,
      },
      {
        path: '/',
        element: (
          <UnsupportedMobile>
            <InitializationLayer>
              <Outlet />
            </InitializationLayer>
          </UnsupportedMobile>
        ),
        children: [
          { path: routes.qrCheckin.route, element: <QrWindow /> },
          { path: routes.signOut.route, element: <SignOut /> },
          { path: routes.auth.route, element: <Auth /> },
          {
            path: '/',
            element: <App />,
            children: [
              {
                path: routes.songs.route,
                handle: { pageTitle: routes.songs.name },
                element: (
                  <PrivateRoute>
                    <Songs />
                  </PrivateRoute>
                ),
              },
              {
                path: routes.songFolder.route,
                handle: { pageTitle: routes.songFolder.name },
                element: (
                  <PrivateRoute>
                    <SongFolder />
                  </PrivateRoute>
                ),
              },
              {
                path: routes.song.route,
                handle: { pageTitle: routes.song.name },
                element: (
                  <PrivateRoute>
                    <Song />
                  </PrivateRoute>
                ),
                children: songRoutes,
              },
              {
                path: routes.playlists.route,
                handle: { pageTitle: routes.playlists.name },
                element: (
                  <PrivateRoute>
                    <Playlists />
                  </PrivateRoute>
                ),
              },
              {
                path: routes.playlist.route,
                handle: { pageTitle: routes.playlist.name },
                element: (
                  <PrivateRoute>
                    <Playlist />
                  </PrivateRoute>
                ),
              },
              {
                path: routes.playerPlaylist.route,
                handle: { pageTitle: routes.playerPlaylist.name },
                element: (
                  <PrivateRoute>
                    <AudioPlayerPlaylistView />
                  </PrivateRoute>
                ),
              },
              {
                path: routes.playerLyrics.route,
                handle: { pageTitle: routes.playerLyrics.name },
                element: (
                  <PrivateRoute>
                    <AudioPlayerLyricsView />
                  </PrivateRoute>
                ),
              },
              {
                path: routes.releases.route,
                handle: { pageTitle: routes.releases.name },
                element: (
                  <PrivateRoute>
                    <Releases />
                  </PrivateRoute>
                ),
              },
              {
                path: routes.releaseVersion.route,
                handle: { pageTitle: routes.releaseVersion.name },
                element: (
                  <PrivateRoute>
                    <ReleaseVersion />
                  </PrivateRoute>
                ),
                children: releaseVersionRoutes,
              },
              {
                path: routes.release.route,
                handle: { pageTitle: routes.release.name },
                element: (
                  <PrivateRoute>
                    <Release />
                  </PrivateRoute>
                ),
              },
              {
                path: routes.profile.route,
                handle: { pageTitle: routes.profile.name },
                element: (
                  <PrivateRoute>
                    <Profile />
                  </PrivateRoute>
                ),
                children: profileRoutes,
              },
              {
                path: routes.settings.route,
                handle: { pageTitle: routes.settings.name },
                element: (
                  <PrivateRoute>
                    <Settings />
                  </PrivateRoute>
                ),
              },
              {
                path: routes.privacySettings.route,
                handle: { pageTitle: routes.privacySettings.name },
                element: (
                  <PrivateRoute>
                    <PrivacySettings />
                  </PrivateRoute>
                ),
              },
              {
                path: routes.notifications.route,
                handle: { pageTitle: routes.notifications.name },
                element: (
                  <PrivateRoute>
                    <Notifications />
                  </PrivateRoute>
                ),
              },
              {
                path: routes.messages.route,
                handle: { pageTitle: routes.messages.name },
                element: (
                  <PrivateRoute>
                    <Messages />
                  </PrivateRoute>
                ),
              },
              {
                path: routes.qrLanding.route,
                element: <AppDownload />,
              },
              {
                path: routes.confirmAccount.route,
                element: <ConfirmAccount />,
              },
              {
                path: routes.confirmAccountSuccess.route,
                element: <ConfirmAccountSuccess />,
              },
              {
                path: routes.signIn.route,
                element: (
                  <PublicRoute>
                    <SignIn />
                  </PublicRoute>
                ),
              },
              {
                path: routes.signUp.route,
                element: (
                  <PublicRoute>
                    <SignUp />
                  </PublicRoute>
                ),
              },
              {
                path: '/',
                element: <IndexNavigate />,
              },
              {
                path: routes.passwordReset.route,
                element: (
                  <PublicRoute>
                    <PasswordReset />
                  </PublicRoute>
                ),
              },
              {
                path: routes.import.route,
                handle: { pageTitle: routes.import.name },
                element: (
                  <PrivateRoute>
                    <Import />
                  </PrivateRoute>
                ),
              },
              {
                path: routes.pageNotFound.route,
                element: <PageNotFound />,
              },
              {
                path: '*',
                element: <PageNotFound />,
              },
            ],
          },
        ],
      },
    ],
  },
];
